import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Form,
  FormInstance,
  InputNumber,
  Select,
  Typography,
} from 'antd';
import { site } from '../../../constants';
import { positiveNumberRules, requiredRule } from '../../../utils/formRules';
import { InlineFormItem } from '../../themedComponents';
import { ReportTypes } from '../../../containers/reports';
import { n } from '../../../utils/stringFormat';

interface ExportDataFormProps {
  readonly formInstance: FormInstance;
  readonly onFinish: () => void;
  readonly onUpdate: () => void;
}

const ExportDataForm: React.FC<ExportDataFormProps> = ({
  formInstance,
  onFinish,
  onUpdate,
}) => {
  const { t } = useTranslation(n(site, ['forms']), { nsMode: 'fallback' });

  const exportDataContent: string[] = t('export_data.export_data', {
    returnObjects: true,
  });

  return (
    <Form name="downloadCsv" form={formInstance} onFinish={onFinish}>
      <Form.Item
        name="type"
        rules={requiredRule(t('export_data.report_required'))}
      >
        <Select
          placeholder={t('export_data.report_type_placeholder')}
          onSelect={onUpdate}
        >
          <Select.Option value={ReportTypes.ADOPTION}>
            {ReportTypes.ADOPTION}
          </Select.Option>
          <Select.Option value={ReportTypes.STEWARDSHIP}>
            {ReportTypes.STEWARDSHIP}
          </Select.Option>
          <Select.Option value={ReportTypes.SITE_ACTIVITY}>
            {ReportTypes.SITE_ACTIVITY}
          </Select.Option>
        </Select>
      </Form.Item>
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) =>
          getFieldValue('type') === ReportTypes.SITE_ACTIVITY ? (
            <Form.Item
              name="siteId"
              label={t('export_data.site_id_label')}
              rules={positiveNumberRules(formInstance, 'siteId')}
            >
              <InputNumber
                min={1}
                placeholder={t('export_data.site_id_placeholder')}
                onChange={onUpdate}
              />
            </Form.Item>
          ) : null
        }
      </Form.Item>
      <Typography.Paragraph>
        {exportDataContent[0]}
        <InlineFormItem
          name="previousDays"
          rules={positiveNumberRules(formInstance, 'previousDays')}
        >
          <InputNumber defaultValue={undefined} onChange={onUpdate} />
        </InlineFormItem>
        {exportDataContent[1]}
      </Typography.Paragraph>
      <Form.Item>
        <Button htmlType="submit" size="middle">
          {t('export_data.load_report')}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ExportDataForm;
